module.exports = __webpack_public_path__ + "img/trash.cbc8add9.svg";